import {UserModel} from './_models'
import {getUserByToken} from './_requests'
import {
  getActingBranch,
  isBranchRefusal,
  resolveActingBranch,
  setActingBranch,
} from '../../common/actingBranch'

/**
 * The signed-in user, answered for the branch they work at (Mart v2, actingBranch.ts). A stale
 * branch pick — the branch was closed, or it belonged to another account in this browser — is
 * dropped and the user asked for again rather than signed out; a first visit settles on the main
 * branch, and the user is asked for once more so `shop` describes that branch.
 */
export async function loadCurrentUser(token: string): Promise<UserModel> {
  let data: UserModel
  try {
    ;({data} = await getUserByToken(token))
  } catch (err) {
    if (!isBranchRefusal(err)) {
      throw err
    }
    setActingBranch(null)
    ;({data} = await getUserByToken(token))
  }

  const branch = resolveActingBranch(data, getActingBranch())
  setActingBranch(branch)
  if (branch !== null && branch !== (data.acting_branch_id ?? null)) {
    ;({data} = await getUserByToken(token))
  }
  return data
}
